export default {
  defaultProps: {
    colorScheme: 'black',
  },
}
